import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { modalDanger } from '../modal_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { getUsers, patchUserAuthConnection, patchUserRoles, postInviteUser, removeUser, removeUsers } from './data';
import { errorReceiveInviteUser, errorReceiveRemoveUsers, errorReceiveUpdateUserAuthConnection, errorReceiveUserRoles, errorReceiveUsers, failedReceiveInviteUser, failedReceiveRemoveUsers, failedReceiveUpdateUserAuthConnection, failedReceiveUserRoles, failedReceiveUsers, receiveInviteUser, receiveInviteUsers, receiveRemoveUsers, receiveUpdateUserAuthConnection, receiveUserRoles, receiveUsers } from './slice';
export function* requestInviteUser(action) {
    const { consumerAPI, email, roles } = action.payload;
    try {
        const organization = yield select(getOrganizationSlug);
        const response = yield call(postInviteUser, email, organization, roles, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(appDanger(`${t('FAILED_TO_INVITE', {
                    ns: 'Common'
                })} ${email}`));
                yield put(modalDanger(error));
                yield put(errorReceiveInviteUser(email));
            }
            else if (data) {
                yield put(appSuccess(`${t('SUCCESSFULLY_INVITED', {
                    ns: 'Common'
                })} ${email}`));
                yield put(receiveInviteUser());
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                const { data } = response;
                const { detail = t('ERROR_INVITING_USER', {
                    ns: 'Common'
                }) } = data;
                yield put(appDanger(`${t('FAILED_TO_INVITE', {
                    ns: 'Common'
                })} ${email}`));
                yield put(modalDanger(detail));
                yield put(errorReceiveInviteUser(email));
            }
            else if (response && response.status === 200) {
                yield put(appSuccess(`${t('SUCCESSFULLY_INVITED', {
                    ns: 'Common'
                })} ${email}`));
                yield put(receiveInviteUser());
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveInviteUser(email));
    }
}
export function* requestInviteUsers(action) {
    const { consumerAPI, emails, roles } = action.payload;
    const organization = yield select(getOrganizationSlug);
    for (let i = 0; i < emails.length; i += 1) {
        const email = emails[i];
        try {
            const response = yield call(postInviteUser, email, organization, roles, consumerAPI);
            if (!consumerAPI) {
                const { data, error } = response;
                if (error) {
                    yield put(appDanger(`${t('FAILED_TO_INVITE', {
                        ns: 'Common'
                    })} ${email}`));
                    yield put(modalDanger(error));
                    yield put(errorReceiveInviteUser(email));
                }
                else if (data) {
                    yield put(appSuccess(`${t('SUCCESSFULLY_INVITED', {
                        ns: 'Common'
                    })} ${email}`));
                }
                else {
                    throw new Error(t('NO_DATA_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
            }
            else {
                if (response && response.status !== 200) {
                    const { data } = response;
                    const { detail = t('ERROR_INVITING_USER', {
                        ns: 'Common'
                    }) } = data;
                    yield put(appDanger(`${t('FAILED_TO_INVITE', {
                        ns: 'Common'
                    })} ${email}`));
                    yield put(modalDanger(detail));
                    yield put(errorReceiveInviteUser(email));
                }
                else if (response && response.status === 200) {
                    yield put(appSuccess(`${t('SUCCESSFULLY_INVITED', {
                        ns: 'Common'
                    })} ${email}`));
                    yield put(receiveInviteUser());
                }
                else {
                    throw new Error(t('NO_DATA_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
            }
        }
        catch (e) {
            yield put(failedReceiveInviteUser(email));
        }
    }
    yield put(receiveInviteUsers());
}
export function* requestRemoveUsers(action) {
    try {
        const { consumerAPI, selectedUsers } = action.payload;
        const organization = yield select(getOrganizationSlug);
        if (!consumerAPI) {
            const response = yield call(removeUsers, organization, selectedUsers);
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveRemoveUsers());
            }
            else if (data && data.removed_users && data.removed_users.length > 0) {
                const removedUsers = data.removed_users.map(removedUser => {
                    return removedUser.email;
                });
                yield put(receiveRemoveUsers(removedUsers));
                const { removed_users } = data;
                const numberOfUsers = removed_users.length;
                if (numberOfUsers > 0) {
                    yield put(appSuccess(`${t('SUCCESSFULLY_REMOVED', {
                        ns: 'Common'
                    })} ${numberOfUsers} ${t('USER_S', {
                        ns: 'Common'
                    })}`));
                }
                if (data.users_not_found && data.users_not_found.length > 0) {
                    const numberOfUsersNotFound = data.users_not_found.length;
                    if (numberOfUsersNotFound > 0) {
                        yield put(appDanger(`${t('FAILED_TO_REMOVE', {
                            ns: 'Common'
                        })} ${numberOfUsersNotFound} ${t('USER_S', {
                            ns: 'Common'
                        })}`));
                    }
                }
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            const removedUsers = [];
            const errors = [];
            for (let i = 0; i < selectedUsers.length; i += 1) {
                const user = selectedUsers[i];
                const response = yield call(removeUser, organization, user, consumerAPI);
                if (response && response.status !== 204) {
                    yield put(appDanger(`${t('FAILED_TO_REMOVE', {
                        ns: 'Common'
                    })} ${user}`));
                    errors.push(user);
                }
                else if (response && response.status === 204) {
                    yield put(appSuccess(`${t('SUCCESSFULLY_REMOVED', {
                        ns: 'Common'
                    })} ${user}`));
                    removedUsers.push(user);
                }
                else {
                    throw new Error(t('NO_DATA_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
            }
            if (removedUsers.length > 0) {
                yield put(receiveRemoveUsers(removedUsers));
            }
            if (errors.length > 0) {
                yield put(errorReceiveRemoveUsers());
            }
        }
    }
    catch (e) {
        yield put(failedReceiveRemoveUsers());
        yield put(appDanger(`${t('FAILED_TO_REMOVE', {
            ns: 'Common'
        })} ${t('USER_S', {
            ns: 'Common'
        })}`));
    }
}
export function* requestUpdateUserAuthConnection(action) {
    try {
        const { authConnection, email } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchUserAuthConnection, organization, email, authConnection);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveUpdateUserAuthConnection());
            yield put(appDanger(error));
        }
        else if (data && data.email === email) {
            yield put(receiveUpdateUserAuthConnection());
            yield put(appSuccess(`${t('SUCCESS_REQUEST_UPDATE_USER_AUTH_CONNECTION', {
                ns: 'Common'
            })}: ${email}.`));
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveUpdateUserAuthConnection());
        yield put(appDanger(t('FAILED_REQUEST_UPDATE_USER_AUTH_CONNECTION', {
            ns: 'Common'
        })));
    }
}
export function* requestUpdateUserRoles(action) {
    try {
        const { consumerAPI, email, roles } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchUserRoles, organization, email, roles, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveUserRoles());
                yield put(appDanger(error));
            }
            else if (data && data.email === email) {
                yield put(receiveUserRoles());
                yield put(appSuccess(`${t('SUCCESS_REQUEST_UPDATE_USER_ROLES', {
                    ns: 'Common'
                })} ${email}.`));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                const { data } = response;
                const { detail = t('ERROR_INVITING_USER', {
                    ns: 'Common'
                }) } = data;
                yield put(errorReceiveUserRoles());
                yield put(appDanger(detail));
            }
            else if (response && response.status === 200) {
                yield put(receiveUserRoles());
                yield put(appSuccess(`${t('SUCCESS_REQUEST_UPDATE_USER_ROLES', {
                    ns: 'Common'
                })} ${email}.`));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveUserRoles());
        yield put(appDanger(t('FAILED_REQUEST_UPDATE_USER_ROLES', {
            ns: 'Common'
        })));
    }
}
export function* requestUsers(action) {
    try {
        const { consumerAPI, organizationSlug } = action.payload;
        const response = yield call(getUsers, organizationSlug, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveUsers());
            }
            else if (data) {
                if (data.length < 1) {
                    throw new Error(t('NO_USERS_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveUsers(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveUsers());
            }
            else if (response && response.status === 200) {
                const { data } = response;
                if (data.length < 1) {
                    throw new Error(t('NO_USERS_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveUsers(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveUsers());
    }
}
export function* watchRequestInviteUser() {
    yield takeLatest('users/requestInviteUser', requestInviteUser);
}
export function* watchRequestInviteUsers() {
    yield takeLatest('users/requestInviteUsers', requestInviteUsers);
}
export function* watchRequestRemoveUsers() {
    yield takeLatest('users/requestRemoveUsers', requestRemoveUsers);
}
export function* watchRequestUpdateUserAuthConnection() {
    yield takeLatest('users/requestUpdateUserAuthConnection', requestUpdateUserAuthConnection);
}
export function* watchRequestUpdateUserRoles() {
    yield takeLatest('users/requestUpdateUserRoles', requestUpdateUserRoles);
}
export function* watchRequestUsers() {
    yield takeLatest('users/requestUsers', requestUsers);
}
